<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Purchasing</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cpurchasing/index">Manage Purchase Order</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create Purchase Order</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div  class="card-body custom_bdr_rds">


    <b-modal :id="infoModal3.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >New Mode of Shipment</h5>

      
  
    </template>
    
   <div>
    <div class="row">


<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Mode</label>
        <input  v-model="shipp.mode"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>



</div>


<div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button @click="saveShipment()"   type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Save</button>
        <button  @click="closeShipment()" type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Close</button>
    </div>
    </div>







   </div>

  

  
  </b-modal>




    <b-modal :id="infoModal2.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >New Currency</h5>

      
  
    </template>
    
   <div>
    <div class="row">

<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Currency</label>
        <input  v-model="curr.discription"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Rate</label>
        <input  v-model="curr.rate"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Symbol</label>
        <input  v-model="curr.Symbol"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Code</label>
        <input  v-model="curr.name"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>

</div>


<div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button @click="saveCurrency()"   type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Save</button>
        <button  @click="closeCurrency()" type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Close</button>
    </div>
    </div>







   </div>

  

  
  </b-modal>


  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="xl" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >New Supplier</h5>

      
  
    </template>
    
   <div>
   

    <div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Name</label>
            <input  v-model="supp.sup_name"   style="font-size: small;" class="form-control bdr-rad"  >
            
          
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Reference</label>
            <input  v-model="supp.sup_reference"   style="font-size: small;" class="form-control bdr-rad" >
          
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Contact</label>
            <input  v-model="supp.sup_contact"   style="font-size: small;" class="form-control bdr-rad" >
          
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tel:</label>
            <input  v-model="supp.tel"   style="font-size: small;" class="form-control bdr-rad" >
          
    </div>
    </div>

  </div>
  
<div class="row">

<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Supplier Address Line 1</label>
        <input  v-model="supp.sup_address_1"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Supplier Address Line 2</label>
        <input  v-model="supp.sup_address_2"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Supplier Address Line 3</label>
        <input  v-model="supp.sup_address_3"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Supplier Address Line 4</label>
        <input  v-model="supp.sup_address_4"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>

</div>
<div class="row">

<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Currency</label>
 

        <v-select class="font-size_def" label="discription"  v-model="supp.sup_currency" :options="currencies" ></v-select>
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Country</label>
        <input  v-model="supp.country"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Email</label>
        <input  v-model="supp.email"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">City</label>
        <input  v-model="supp.city"   style="font-size: small;" class="form-control bdr-rad" >
      
</div>
</div>

</div>

<div class="row">

<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Special Notes</label>
        <textarea v-model="supp.remarks" class="form-control bdr-rad" rows="2"></textarea>
      
</div>
</div>

</div>


<div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button @click="saveSupplier()"   type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Save</button>
        <button  @click="closeSuppler()" type="" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Close</button>
    </div>
    </div>





   </div>

  

  
  </b-modal>

   

                    <form @submit.prevent="SaveQuotation()" >


<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier</label>
            <v-select class="font-size_def" label="sup_name"    v-model="squatation.idsup"  :options="suppliers" :class="{'is-invalid': errors.idsup}"></v-select>
            <div class="invalid-feedback">
              {{ errors.idsup }}
            </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;"></label>
            <button type="button"  @click="createSupplier()"  class="btn btn-sm  btn-outline-primary mb-1 mt-4 font-size_def bdr-rad bdr-rad">New Supplier</button>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Purchase Date</label>
            <input type="date" v-model="squatation.perchase_date"   style="font-size: small;" class="form-control bdr-rad" :class="{'is-invalid': errors.perchase_date}">
            <div class="invalid-feedback">
              {{ errors.perchase_date }}
            </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Due Date</label>
            <input type="date"  v-model="squatation.due_date"   style="font-size: small;" class="form-control bdr-rad" :class="{'is-invalid': errors.due_date}">
            <div class="invalid-feedback">
              {{ errors.due_date }}
            </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Follow up Date </label>
           
            <input type="date" v-model="squatation.follow_date"   style="font-size: small;" class="form-control bdr-rad" :class="{'is-invalid': errors.follow_date}">
            <div class="invalid-feedback">
              {{ errors.follow_date }}
            </div>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Ship Country</label>
            <v-select class="font-size_def" label="countryname" v-model="squatation.country"  :options="countries" :class="{'is-invalid': errors.country}"></v-select>
            <div class="invalid-feedback">
              {{ errors.country }}
            </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Currency</label>
            <v-select class="font-size_def" label="discription"  v-model="squatation.currency" :options="currencies" :class="{'is-invalid': errors.currency}"></v-select>
            <div class="invalid-feedback">
              {{ errors.currency }}
            </div>
    </div>
  </div>


  <div class="col-md-3">
    <div class="form-group ">
        <label class="custom-label" style="font-size: small;"></label>
        <button type="button"  @click="createCurrency()"  class="btn btn-sm  btn-outline-primary mb-1 mt-4 font-size_def bdr-rad bdr-rad">New Currency</button>
    </div>
  </div>

  
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Upload Document</label>
            <input type="file"    style="font-size: small;" class="form-control bdr-rad">
           
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Mode of Shipment</label>
            <v-select class="font-size_def" label="mode"  v-model="squatation.shipment" :options="shipments" :class="{'is-invalid': errors.shipment}" ></v-select>
            <div class="invalid-feedback">
              {{ errors.shipment }}
            </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
        <label class="custom-label" style="font-size: small;"></label>
        <button type="button"  @click="createShipment()"  class="btn btn-sm  btn-outline-primary mb-1 mt-4 font-size_def bdr-rad bdr-rad">New Shipment Mode</button>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
        <label class="custom-label" style="font-size: small;">Stock Order #</label>
        <input type="" v-model="squatation.stock_oder"   style="font-size: small;" class="form-control bdr-rad" >
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-3">
    <label class="custom-label" style="font-size: small;">Remarks</label>
    <textarea v-model="squatation.remarks" class="form-control bdr-rad" rows="2"></textarea>


    </div>
</div>














<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>PO Item</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead  class="background_color2">
          <tr >
                <th ></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Product Description</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Requested Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Unit Price</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Total </label>
                  </div>
                </th>
                
               
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>  <b-icon @click="remove" v-show="this.count>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon> </td>
              <td style="width: 20%;">
                <v-select  v-model="detail[0].idproduct" label="label"  :options="mproducts" @input="loadPrice(0)"></v-select>
              </td>
             
              <td><input  v-model="detail[0].P_description" style="font-size: small;" class="form-control  bdr-rad" disabled></td>
              <td><input  v-model="detail[0].qty" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculateqty(0)" ></td>
              <td>
                <input  v-model="detail[0].unit_price" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculatediscount(0)">
              </td>
              <td><input  v-model="detail[0].line_amount"   style="font-size: small;" class="form-control text_right bdr-rad" disabled></td>
             
             
              
              <td class="custom-icon">  <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
              <td> <v-select v-model="detail[key].idproduct" label="label"  :options="mproducts" @input="loadPrice(key)"></v-select></td>
             
              <td><input  v-model="detail[key].P_description" style="font-size: small;" class="form-control  bdr-rad" disabled></td>
              <td><input  v-model="detail[key].qty" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculateqty(key)" ></td>
              <td><input  v-model="detail[key].unit_price" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculatediscount(key)" ></td>
              <td><input  v-model="detail[key].line_amount" style="font-size: small;" class="form-control text_right bdr-rad" disabled></td>
              

              


              <td class="custom-icon"> 
              
                 <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
           
            
            <tr >
                <td> </td>
              <td></td>
              <td>Sub Total</td>
             
              
              <td></td>
              <td></td>
              <td class="text_right" >{{ subtotal }}</td>
             
              <td></td>
            
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Special Discount</td>
             
              
              <td></td>
              <td></td>
              <td><input v-model="quotation.special_discount"  style="font-size:small" class="form-control text_right bdr-rad" @input="spe_dis"></td>
           
             
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Total</td>
            
              
              <td></td>
              <td></td>
              <td class="text_right">{{ final_total }}</td>
          
              <td></td>
              
            </tr>

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSupplier();
    this.loadCustomer();

      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
    
        mproducts:[],
       
        currencies:[],
        counties:[],
        counties:[],
        shipments:[],
      salespeoples:[

      ],
      errors: {},
      curr: {},
      shipp: {},
     
      squatation:{},
      supp:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        Brands:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },
      infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],
        validity_periodop: [
            { label: 'Select', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {


          validate(){
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const mobilePattern = /^\+94\d{2}\d{3}\d{4}$/; 
    // const mobilePattern = /^(?:\+47\d{8}|0\d{9})$/;
    const mobilePattern = /^(?:\+94|0)\d{9}$/;
    // const mobilePattern = /^(?:\+46|0)([ -]?\d){9}$/;
      this.errors = {};
      if(this.squatation.idsup == null){
        this.$set(this.errors, 'idsup', "Supplier field is required");
        
      }
      if(this.squatation.perchase_date == null){
        this.$set(this.errors, 'perchase_date', "Purchase Date field is required");
      }
      if(this.squatation.due_date== null){
        this.$set(this.errors, 'due_date', "Due Date is required");
      }
      if(this.squatation.follow_date == null){
        this.$set(this.errors, 'follow_date', "Follow up Date field is required");
      }
      if(this.squatation.country == null){
        this.$set(this.errors, 'country', "Country field is required");
      }
      if(this.squatation.currency == null){
        this.$set(this.errors, 'currency', "Currency field is required");
      }
      if(this.squatation.shipment == null){
        this.$set(this.errors, 'shipment', "Mode of Shipment field is required");
      }
      // if(this.issue.first_name == null){
      //   this.$set(this.errors, 'first_name', "First name is required");
      // }
      // if(this.issue.surname == null){
      //   this.$set(this.errors, 'surname', "Surename is required");
      // }
      // if (!emailPattern.test(this.issue.email)) {
      //   this.$set(this.errors, 'email', "Please enter a valid email address");
      // }
    
//       if (!this.issue.mobile) {
//         this.$set(this.errors, 'mobile', "Mobile number is required");
//     } else {
//         try {
//           const phoneNumber = libphonenumber.parsePhoneNumber(this.issue.mobile, 'SE'); // 'SE' for Sweden

// // Validate number and prefix
// if (phoneNumber.isValid() && phoneNumber.country === 'SE') {
//   const validPrefixes = ['4670', '4671', '4672', '4673', '4676', '4679'];
//   const prefix = phoneNumber.number.slice(1, 5); // Extract "+467x"

//   if (!validPrefixes.includes(prefix)) {
//     addError('mobile', "Invalid Swedish mobile number.");
//   }
// } else {
//   addError('mobile', "Please enter a valid mobile number");
// }
//         } catch (error) {
//             this.$set(this.errors, 'mobile', "Please enter a valid mobile number");
//         }
//     }
      // if(this.squatation.customer_contact == null){
      //   this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      // }
      // if(this.sales == null){
      //   this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      // }
      // if(this.quotation.id_brand == null){
      //   this.$set(this.errors, 'idbrandError', "Brand field is required");
      // }
     },


     async SaveQuotation() {
     
     this.validate();

     if(Object.keys(this.errors).length === 0){
       try {
        const { data} = await  axios.post('/ppurchasing/create',{userid:this.userid,squatation:this.squatation,detail:this.detail},{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
       if(data.status==200){
         this.$router.push('/cpurchasing/index');
       }
         
          
        
      } catch (error) {
        console.log(error.response);
      }
     }
      
     

     
    },


    async createShipment() {
      
      
       
      this.$root.$emit('bv::show::modal', this.infoModal3.id);
  
   
 
},
    async closeShipment() {


   
      this.$root.$emit('bv::hide::modal', this.infoModal3.id);
  
   
 
},

async saveShipment() {
       
     
       try {
         const { data} = await  axios.post('/msupplier/createshipment',{shipp:this.curr,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            window.location.reload();
          }
        
         
       } catch (error) {
         console.log(error.response);
       }
     },





     async createCurrency() {
      
      
       
      this.$root.$emit('bv::show::modal', this.infoModal2.id);
  
   
 
},
    async closeCurrency() {


   
      this.$root.$emit('bv::hide::modal', this.infoModal2.id);
  
   
 
},

async saveCurrency() {
       
     
       try {
         const { data} = await  axios.post('/msupplier/createcurrency',{curr:this.curr,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            window.location.reload();
          }
        
         
       } catch (error) {
         console.log(error.response);
       }
     },





          async createSupplier() {
      
      
       
            this.$root.$emit('bv::show::modal', this.infoModal1.id);
        
         
       
     },
          async closeSuppler() {
      
      
         
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        
         
       
     },


     async saveSupplier() {
       
     
       try {
         const { data} = await  axios.post('/msupplier/createsub',{supp:this.supp,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            window.location.reload();
          }
        
         
       } catch (error) {
         console.log(error.response);
       }
     },


     


          async loadSupplier() {
       
     
      try {
        const { data} = await  axios.get('/msupplier/supplierload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.suppliers = data.suppliers;
         this.countries = data.countries;
         this.shipments = data.shipments;
         this.currencies = data.currency;
         this.squatation.usd_rate = data.usd_rate;
        
        
      } catch (error) {
        console.log(error.response);
      }
    },

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload1',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
       
      
       
          this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }
     },

    

     async loadBrand() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadproduct',{id_brand:this.quotation.id_brand},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mproducts = data.mproducts;
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadPrice(id) {
       
     
       try {
         const { data} = await  axios.post('/mproduct/loadproduct',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'P_description', data.P_description);
        //  this.$set(this.detail[id], 'avlqty', data.avl);
        //  this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calculateqty(id) {
    
    if(this.detail[id].unit_price==null){
      this.detail[id].unit_price=0;
    }
    
    
  const line_amount = (this.detail[id].unit_price * this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);



  let line_amount_tot = 0;
  
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].unit_price * this.detail[i].qty;



  }

  this.subtotal = line_amount_tot.toFixed(2);
  



  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].unit_price * this.detail[id].qty;
  this.$set(this.detail[id], 'line_amount', line_amount);



  let line_amount_tot = 0;
  
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].unit_price * this.detail[i].qty;


 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


    

    

    


     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     

   
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    